import { Typography, Box } from "@mui/material";
import DummyTable from "components/DummyViews/DummyTable";
import FormDialog from "components/ManagerModals/ViewModal";
import PeriodLogsTable from "components/Tables/periodLogsTable";
import { useState } from "react";
import { usePeriodErrorLogs } from "services/hooks/rentals";
import ErrorDetailsForm from "./errorDetailsForm";



export default function PeriodLogs() {
    const {periodErrorLogs, isLoadingPeriodErrorLogs} = usePeriodErrorLogs();
    const [openDialog, setOpenDialog] = useState(false);
    const [activeItem, setActiveItem] = useState({});

    const handleClickViewDetails = (row)=>{
      setActiveItem(row);
      handleOpenDialog();
    }

    const handleOpenDialog=()=>{
      setOpenDialog(true);
    }
    const handleCloseDialog=()=>{
      setOpenDialog(false);
    }

    return (
      <Box>
        <Typography variant="h4" fontWeight="bold" sx={{ marginBottom:"10px" }}>Period Logs</Typography>
        {isLoadingPeriodErrorLogs ? <DummyTable/> : <PeriodLogsTable tableContent={periodErrorLogs} handleClickViewDetails={handleClickViewDetails} />}
        <FormDialog
          title="Error Details"
          open={openDialog}
          handleClose={handleCloseDialog}
          text="Detailed description fo the error"
          content={<ErrorDetailsForm errorData={activeItem}/>}
        />
      </Box>
    );
}